<template>
  <div v-if="clinvarTableData" class="clinvar-statistic-table-page col-block width-full">
    <div class="clinvar-statistic-table-container col-block width-full">
      <div
        class="clinvar-statistic-table-row row-block stretch"
        v-for="(csqKey, csqIndex) in Object.keys(clinvarTableData['config']['csq'])"
        :key="csqIndex"
        :class="['csq-' + csqKey]"
      >
        <div
          class="clinvar-statistic-table-col col-block"
          v-for="(gsKey, gsIndex) in Object.keys(clinvarTableData['config']['gs'])"
          :key="gsIndex"
          :class="['csq-' + csqKey, 'gs-' + gsKey]"
          :style="{
            flex: clinvarTableData['config']['gs'][gsKey].flex || 1,
            'min-height': '50px',
            '--color': clinvarTableData['config']['gs'][gsKey].color,
            '--bgColor': (
              clinvarTableData['config']['gs'][gsKey].color +
              (!(['title', 'total'].includes(csqKey) || ['title', 'total'].includes(gsKey)) ?
              clinvarTableData['function'].getOpacity(clinvarTableData['data']['csq'][csqKey][gsKey].n ? clinvarTableData['data']['csq'][csqKey][gsKey].n / clinvarTableData['data']['gs'][gsKey].total : 0)
              : '')
            )
          }"
        >
          <div :style="{ flex: 1 }"></div>
          <div class="clinvar-statistic-table-cell row-block flex-wrap">
            <template v-if="['title'].includes(csqKey)">
              <template v-if="true">
                <div
                  class="clinvar-statistic-table-content break-line"
                >{{ $t(clinvarTableData['config']['gs'][gsKey].title) }}</div>
              </template>
            </template>
            <template v-else-if="['total'].includes(csqKey)">
              <template v-if="['title'].includes(gsKey)">
                <div
                  class="clinvar-statistic-table-content break-line"
                >{{ $t(clinvarTableData['config']['csq'][csqKey].title) }}</div>
              </template>
              <template v-else-if="['total'].includes(gsKey)">
                <div
                  class="clinvar-statistic-table-content break-line"
                >{{ toPriceString(clinvarTableData['data']['csq'].total) }}</div>
              </template>
              <template v-else>
                <div
                  class="clinvar-statistic-table-content break-line"
                >{{ toPriceString(clinvarTableData['data']['gs'][gsKey].total) }}</div>
              </template>
            </template>
            <template v-else>
              <template v-if="['title'].includes(gsKey)">
                <div
                  class="clinvar-statistic-table-content break-line"
                >{{ $t(clinvarTableData['config']['csq'][csqKey].title) }}</div>
              </template>
              <template v-else-if="['total'].includes(gsKey)">
                <div
                  class="clinvar-statistic-table-content break-line"
                >{{ toPriceString(clinvarTableData['data']['csq'][csqKey].total) }}</div>
              </template>
              <template v-else>
                <div
                  class="clinvar-statistic-table-content break-line"
                  :class="{ 'empty': !clinvarTableData['data']['csq'][csqKey][gsKey].n }"
                >{{ toPriceString(clinvarTableData['data']['csq'][csqKey][gsKey].n) + (clinvarTableData['data']['csq'][csqKey][gsKey].n ? ' /' : '') }}</div>
                <div
                  v-if="clinvarTableData['data']['csq'][csqKey][gsKey].n"
                  class="clinvar-statistic-table-content break-line"
                >{{ fixNumber(100 * clinvarTableData['data']['csq'][csqKey][gsKey].n / clinvarTableData['data']['gs'][gsKey].total, 0.001) + '%' }}</div>
              </template>
            </template>
          </div>
          <div :style="{ flex: 1 }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getClinvarStatisticData } from '../../constants/global/data'
import { toPriceString, fixNumber } from '../../constants/global/util'

export default {
  props: {
    defaultData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      clinvarTableData: null
    }
  },
  computed: {
    // global
    toPriceString () { return toPriceString },
    fixNumber () { return fixNumber }
  },
  watch: {
    'defaultData' () {
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.clinvarTableData = getClinvarStatisticData(this.defaultData)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/case/clinvarStatisticTable.vue